module.exports = __webpack_public_path__ + "img/dollarv2.28c30daf.svg";